import { useEffect } from "react";
import { GetBanners, GetHomeData } from "../../store/Actions/action";
import { useReduxStore } from "../../hooks/useReduxStore";
import { updateItem } from "../../store/Reducers/itemReducer";
import { useNavigate } from "react-router-dom";
import { updateHome } from "../../store/Reducers/homeReducer";

const useLandingNew = () => {
  const { getState, dispatch } = useReduxStore();
  const navigate = useNavigate();
  const {
    categories,
    selectedCategory,
    homeBanners,
    popularLoading,
    trendingLoading,
    categoriesItems,
    popularItems,
    trendingItems,
  } = getState("Home");

  useEffect(() => {
    dispatch(GetBanners());
    dispatch(GetHomeData());
    dispatch(updateItem({ itemDetail: {} }));
  }, [dispatch]);

  const onCategorySelect = (categoryName) => {
    // Match the selected category by name/type from the API categories
    const normalizedSelectedName = categoryName.toLowerCase().replace(/[^a-z]/g, "");

    // Find matching category in Redux store
    const matchedCategory = categories.find((cat) => {
      const normalizedCatName = cat.name.toLowerCase().replace(/[^a-z]/g, "");
      // Special mappings if names differ slightly
      if (normalizedSelectedName === "audiobooks" && normalizedCatName === "audiobooks") return true;
      if (normalizedSelectedName === "audiobooks" && normalizedCatName === "audiobook") return true;
      if (normalizedSelectedName === "ebooks" && normalizedCatName === "ebooks") return true;
      if (normalizedSelectedName === "ebooks" && normalizedCatName === "ebook") return true;
      if (normalizedSelectedName === "movies" && normalizedCatName === "movies") return true;
      if (normalizedSelectedName === "movies" && normalizedCatName === "movie") return true;
      if (normalizedSelectedName === "songs" && normalizedCatName === "music") return true;
      if (normalizedSelectedName === "songs" && normalizedCatName === "songs") return true;
      if (normalizedSelectedName === "songs" && normalizedCatName === "musics") return true;
      if (normalizedSelectedName === "exclusivecontent" && normalizedCatName === "streamedaudio") return true;
      // console.log(normalizedSelectedName, 'normalizedSelectedName');
      // console.log(normalizedCatName, 'normalizedCatName');
      return normalizedCatName === normalizedSelectedName;
    });

    if (matchedCategory) {
      dispatch(updateHome({ selectedCategory: matchedCategory }));
      navigate("/ProductCollection", { state: {} });
    } else {
      // Fallback
      if (categoryName.toLowerCase().includes("exclusive")) {
        navigate("/NewsFeed");
      } else {
        navigate("/ProductCollection", { state: {} });
      }
    }
  };

  return {
    categories,
    selectedCategory,
    homeBanners,
    popularLoading,
    trendingLoading,
    categoriesItems,
    popularItems,
    trendingItems,
    onCategorySelect,
  };
};

export default useLandingNew;
